export enum ActionType {
  UPDATE_STATE = 'LBS_UPDATE_STATE'
}
